import React, { useEffect, useState } from "react";
import EmailTemplateService from "../../../services/KangarooServices/EmailTemplateService";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const EmailTemplateDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState(null);

  const fetchDetail = async () => {
    try {
      const response = await EmailTemplateService.getbyId(id);
      setDetailData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (id) fetchDetail();
  }, [id]);

  if (!detailData) return null;
  const breadcrumbItems = [{ title: "Back to List", link: "/email-templates" }];

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Email Template Detail"
          pageTitle="Email Template"
          breadcrumbItems={breadcrumbItems}
        />
        <Row className="justify-content-center mt-5">
          <Col md="8" lg="8">
            <Card className="shadow border-0 rounded-4">
              {/* Header */}
              {/* <CardHeader
                className="text-center text-white fw-bold"
                style={{ background: "#7b2d8e", fontSize: "22px" }}
              >
                {detailData.subject}
              </CardHeader> */}

              {/* Body */}
              <CardBody className="p-4">
                <p
                  className="text-center fw-bold"
                  style={{ lineHeight: "1.6", fontSize: "18px" }}
                >
                  {detailData.subject}
                </p>

                {/* Render HTML body from API */}
                <div
                  style={{ lineHeight: "1.6", fontSize: "15px" }}
                  dangerouslySetInnerHTML={{ __html: detailData.body }}
                />

                {/* CTA */}
                {/* <div className="text-center my-4">
                  <Button
                    style={{ background: "#7b2d8e", border: "none" }}
                    className="px-4"
                  >
                    Get Started
                  </Button>
                </div> */}
              </CardBody>

              {/* Footer */}
              {/* <div className="bg-light text-center py-2 small text-muted">
                © 2026 Your Company. All rights reserved.
              </div> */}
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default EmailTemplateDetail;
